export default "__VITE_ASSET__DPXTupkL__"